module.exports = __webpack_public_path__ + "static/media/transocksWechat.2271bd03.png";